<template>
    <div class="">
        <v-row>
            <v-col>
                <b-text-field class="mb-6 mx-4" label="Versienummer" v-model="value.version" :validation="validations.version" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <basic-wysiwyg-input class="mx-4" value="changelog" :unique-value="'content' + (value.version ? value.version.toString().split('.')[0] + value.version.toString().split('.')[1] + value.version.toString().split('.')[1] : 'new')" :validation="validations.content" v-model="value.content" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BasicWysiwygInput from "@/components/General/Form/Wysiwyg/BasicWysiwygInput.vue";
import BTextField from "@/components/General/Form/BTextField.vue";

export default {
    components: {
        BTextField,
        BasicWysiwygInput
    },
    props: {
        value: {
            required: true,
        },
        validations: {
            required: true,
        }
    },
}
</script>
